import { IsArray, IsObject } from 'helpers/ValueTests'
import { each } from 'helpers/Objects'

const RESPONSE_OK = "OK"
const RESPONSE_ERROR = "ERROR"

const Helpers = {
    GetImage: ( id, size = 'full' ) => `/api/images/${id}/${size}`,
    GetVideo: id => `/api/video/${id}.mp4`
}

function RequestError( errors ) {
    Error.call( this, errors )

    this.name = "RequestError"
    this.errors = errors
    
    let error_texts = []

    if( IsArray( errors ) )
    {
        errors.forEach( item => {
            if( IsArray( item ) )
            {
                error_texts = [ ...error_texts, ...item ]
            } else {
                error_texts = [ ...error_texts, item ]
            }
        })
    } else if( IsObject( errors ) ) {
        each( errors, ( attr, item ) => {
            if( IsArray( item ) )
            {
                error_texts = [ ...error_texts, ...item ]
            } else {
                error_texts = [ ...error_texts, item ]
            }
        } )
    }

    this.message = error_texts.join( "\n" )

    if( Error.captureStackTrace )
    {
        Error.captureStackTrace(this, RequestError)
    } else {
        this.stack = (new Error()).stack
    }
}

RequestError.prototype = Object.create( Error.prototype )

const Request = async ( api, ...args ) => {
    const request = await api( ...args )

    if( request && request.status == RESPONSE_OK )
    {
        const { response } = request

        return response
    } else if ( request && request.status == RESPONSE_ERROR ) {
        throw new RequestError( request.errors )
    } else {
        throw new Error( "Server unreacheble" )
    }
}

export { Request, Helpers }

/*EXAMPLES:
    const response = await Request( ProductApi.getById, product_id )
*/